import TokenView from '@/language/es/views/TokenView';

export default {
  TokenView,
};
